function Validator_compare(element) {
    this.$element = $(element);

    this.selectors = {
	    formParent: 'form[data-i4-decorator="Validator_form"]'
    };

    this.data = {
	    required: 'required',
	    messageFail: 'message-fail',
	    compareField: 'compare-field',
		validateOnSubmit: 'validate-on-submit'
    };

    this.triggers = {
	    validate: 'i4:validate',
	    updateView: 'i4:updateView',
	    refresh: 'i4:refresh'
    };

    this.classNames = {
	    failMessage: 'fail-message'
    };

    this.init = function() {

	    // console.log('init - compare');

	    this.dataRequired = this.$element.data(this.data.required);
	    this.dataMessageFail = this.$element.data(this.data.messageFail);
	    this.dataCompareField = this.$element.data(this.data.compareField);

	    this.$formParent = this.$element.parents(this.selectors.formParent);
		this.$compareField = this.$formParent.find('#'+this.dataCompareField);

		this.$formParent.trigger(this.triggers.refresh);

	    this.$element.on(this.triggers.validate, this.validate.bind(this));
	    this.$element.on('keyup blur change', this.$elementChange.bind(this));
		this.$compareField.on('keyup blur change', this.$elementChange.bind(this));

		this.validateOnSubmit = this.$formParent.length && this.$formParent.data(this.data.validateOnSubmit);
		this.prepareFailMessage();

		if (!this.validateOnSubmit) {
			this.validate();
		}
    };

    this.$elementChange = function() {
	    this.validate();

	    this.$formParent.trigger(this.triggers.updateView);
    };

    this.validate = function() {
	    this.value = this.$element.val();
	    this.compareFieldValue = this.$compareField.val();
	    this.compareFieldValid = this.$compareField.hasClass('valid');

	    var isSame = this.compareFieldValue === this.value;

	    this.$element.removeClass('invalid');
		this.$element.removeClass('valid');

		if (isSame) {
			this.$element.addClass('valid');
		} else if (this.value != '' || this.dataRequired) {
			this.$element.addClass('invalid');

			if (this.validateOnSubmit || this.value != '') {
				this.$failMessage.show();
			} else {
				this.$failMessage.hide();
			}
		}
    };

    this.prepareFailMessage = function() {
	    this.$failMessage = $('<div></div>');

	    if (this.dataMessageFail !== undefined) {
		    this.$failMessage.
		    	addClass(this.classNames.failMessage).
		    	html(this.dataMessageFail).
		    	hide();

		    this.$element.after(this.$failMessage);
	    }
    };

}
